<template>
  <div class="user-detail-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="info-box left-box">
          <div class="title">用户基本信息：</div>
          <div class="info" style="justify-content: flex-start;">
            <div class="img-box">
              <div>
                <el-image
                  class="img"
                  :src="userDetail.avatar"
                  fit="cover"
                ></el-image>
              </div>
            </div>
            <div class="des">
              <div class="item" style="margin-right: 10px">
                <p>用户昵称：{{ userDetail.nickname }}</p>
                <p>用户ID：{{ userDetail.uid }}</p>
                <p>电话：{{ userDetail.phone }}</p>
              </div>
              <div class="item">
                <p>会员等级：{{ roleMap[userDetail.roleTypeOne] }}</p>
                <p>喂养方式：{{ feedModeMap[userDetail.feedMode] }}</p>
                <p>喂养奶粉：{{ userDetail.productName }}</p>
              </div>
              <div class="item">
                <p>宝宝币总充值额：{{ userDetail.rechargeBalance }}</p>
                <p>
                  宝宝币余额：{{ userDetail.balance }}
                  <span class="btn" @click="addBalanceModal">修改</span>
                </p>
                <p>总兑换次数：{{ userDetail.conversionNumber }}</p>
              </div>
              <div class="item">
                <p>已使用咨询次数：{{ userDetail.usedNumber }}</p>
                <p>待使用咨询次数：{{ userDetail.waitNumber }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="tabs">
            <div
              class="tab"
              :class="{ active: tabActive === item.value }"
              v-for="item in tabList"
              :key="item.value"
              @click="tabChange(item.value)"
            >
              {{ item.name }}
              <div class="tab-line"></div>
            </div>
          </div>
          <div class="family-box" v-if="tabActive === 1">
            <div class="family-item" v-for="item in familyList" :key="item.fid">
              <div class="left">
                <div class="iconfont icon-youjiantou-24 icon"></div>
              </div>
              <div class="info">
                <div class="row">
                  <div class="info-left">
                    家庭组名称：
                  </div>
                  <div class="info-right">
                    {{ item.familyName }}
                  </div>
                </div>
                <div class="row">
                  <div class="info-left">
                    关联宝宝昵称：
                  </div>
                  <div class="info-right">
                    {{
                      item.babyNickname && item.babyNickname.length
                        ? item.babyNickname.join("、")
                        : "无"
                    }}
                  </div>
                </div>
                <div class="row">
                  <div class="info-left">
                    本用户角色：
                  </div>
                  <div class="info-right">
                    {{ item.familyRole }}
                  </div>
                </div>
                <div class="row">
                  <div class="info-left">
                    创建时间：
                  </div>
                  <div class="info-right">
                    {{ item.created }}
                  </div>
                </div>
              </div>
              <div class="member-box">
                <div class="title">成员列表：</div>
                <div class="member-table">
                  <el-table
                    :data="item.memberList"
                    class="order-table table"
                    ref="orderTable"
                    style="margin-top: 0;"
                    border
                    :header-cell-style="{
                      border: 'none',
                      color: '#666',
                      fontWeight: 'normal',
                      background: '#f6f6f6',
                      borderBottom: '1px solid #E8E8E8',
                      height: '32px',
                      fontSize: '14px',
                    }"
                    :row-style="{
                      height: '32px',
                      fontSize: '14px',
                    }"
                  >
                    <el-table-column
                      prop="uid"
                      align="center"
                      label="用户ID"
                    ></el-table-column>
                    <el-table-column prop="avatar" align="center" label="头像">
                      <div slot-scope="scope">
                        <el-image
                          class="brand-pic"
                          :src="scope.row.avatar"
                          style="width: 32px;height: 32px;"
                          :preview-src-list="[scope.row.avatar]"
                        >
                        </el-image>
                      </div>
                    </el-table-column>
                    <el-table-column
                      prop="nickname"
                      align="center"
                      label="用户昵称"
                    ></el-table-column>
                    <el-table-column
                      prop="phone"
                      align="center"
                      label="绑定手机号"
                      width="120"
                    ></el-table-column>
                    <el-table-column
                      prop="familyRole"
                      align="center"
                      label="用户角色"
                    ></el-table-column>
                    <el-table-column
                      prop="roleTypeOne"
                      align="center"
                      label="会员等级"
                    >
                      <div slot-scope="scope">
                        {{ roleMap[scope.row.roleTypeOne] || "-" }}
                      </div>
                    </el-table-column>
                    <el-table-column
                      prop="created"
                      align="center"
                      label="是否管理员"
                      width="100"
                    >
                      <div slot-scope="scope">
                        {{ scope.row.manager === 1 ? "是" : "否" }}
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <div class="baby-box" v-if="tabActive === 2">
            <div class="baby-table-box">
              <el-table
                :data="babyList"
                class="order-table table baby-table"
                ref="orderTable"
                style="margin-top: 0;"
                border
                :header-cell-style="{
                  border: 'none',
                  color: '#666',
                  fontWeight: 'normal',
                  background: '#f6f6f6',
                  borderBottom: '1px solid #E8E8E8',
                  height: '32px',
                  fontSize: '14px',
                }"
                :row-style="{
                  height: '32px',
                  fontSize: '14px',
                }"
              >
                <el-table-column prop="babyAvatar" align="center" label="头像">
                  <div slot-scope="scope">
                    <el-image
                      class="brand-pic"
                      :src="scope.row.babyAvatar"
                      v-if="scope.row.babyAvatar"
                      style="width: 32px;height: 32px;"
                      :preview-src-list="[scope.row.babyAvatar]"
                    >
                    </el-image>
                    <div v-else>无</div>
                  </div>
                </el-table-column>
                <el-table-column
                  prop="babyNickname"
                  align="center"
                  label="宝宝昵称"
                ></el-table-column>
                <el-table-column prop="gender" align="center" label="性别">
                  <div slot-scope="scope">
                    {{ scope.row.gender === 1 ? "男" : "女" }}
                  </div>
                </el-table-column>
                <el-table-column
                  prop="birthday"
                  align="center"
                  label="出生日期"
                ></el-table-column>
                <el-table-column
                  prop="birthWeight"
                  align="center"
                  label="出生体重"
                ></el-table-column>
                <!-- <el-table-column
                  prop="nickname"
                  align="center"
                  label="过敏史"
                ></el-table-column> -->
                <el-table-column
                  prop="constitution"
                  align="center"
                  label="体质"
                ></el-table-column>
                <el-table-column
                  label="操作"
                  align="center"
                  width="90"
                  class-name="baby-btn-box"
                >
                  <div
                    slot-scope="scope"
                    style="display: flex;justify-content: center;"
                  >
                    <div class="table-btn-box">
                      <button
                        size="mini"
                        class="table-btn"
                        style="color: #5283FF;cursor: pointer;"
                        @click="handleBabyInfo(scope.row.bid)"
                      >
                        查看
                      </button>
                      <!-- <div class="arrow">

                      </div> -->
                    </div>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div class="baby-right" v-if="babyTabActive" :key="timeStamp">
              <div class="tabs">
                <div
                  class="tab"
                  :class="{ active: babyTabActive === item.value }"
                  v-for="item in babyTabList"
                  :key="item.value"
                  @click="babyTabChange(item.value)"
                >
                  {{ item.name }}
                  <div class="tab-line"></div>
                </div>
              </div>
              <div v-if="babyTabActive === 1">
                <el-table
                  :data="recordFeedList"
                  class="order-table table baby-table"
                  ref="orderTable"
                  style="margin-top: 0;"
                  border
                  :header-cell-style="{
                    border: 'none',
                    color: '#666',
                    fontWeight: 'normal',
                    background: '#f6f6f6',
                    borderBottom: '1px solid #E8E8E8',
                    height: '32px',
                    fontSize: '14px',
                  }"
                  :row-style="{
                    height: '32px',
                    fontSize: '14px',
                  }"
                >
                  <el-table-column
                    prop="feedAmount"
                    align="center"
                    label="喂养量"
                  >
                    <div slot-scope="scope">{{ scope.row.feedAmount }}ml</div>
                  </el-table-column>
                  <el-table-column
                    prop="feedTime"
                    align="center"
                    label="日期时间"
                    width="180"
                  ></el-table-column>
                  <el-table-column
                    prop="feedMode"
                    align="center"
                    label="喂养方式"
                  >
                    <div slot-scope="scope">
                      {{ feedModeMap[scope.row.feedMode] }}
                    </div>
                  </el-table-column>
                  <el-table-column
                    prop="nickname"
                    align="center"
                    label="维护人昵称"
                    width="90"
                  ></el-table-column>
                  <el-table-column
                    prop="familyRole"
                    align="center"
                    label="维护人角色"
                    width="90"
                  ></el-table-column>
                </el-table>
              </div>
              <div v-if="babyTabActive === 2">
                <div
                  class="echarts-box"
                  id="echarts"
                  style="width: 600px;height: 300px;"
                ></div>
              </div>
              <div v-if="babyTabActive === 3">
                <div class="remark-box">
                  <div
                    class="remark-item"
                    v-for="item in growthRemarkList"
                    :key="item.id"
                  >
                    <div class="text">
                      {{ item.content }}
                    </div>
                    <div class="pics">
                      <el-image
                        style="width: 80px; height: 80px;margin-right: 10px;"
                        :src="item"
                        v-for="(item, index) in item.pics"
                        :preview-src-list="item.pics"
                        :key="index"
                        fit="contain"
                      ></el-image>
                    </div>
                    <div class="remark-bottom">
                      <div class="name">
                        发布人：{{ item.nickname }}/{{ item.familyRole }}
                      </div>
                      <div class="date">{{ item.remarkTime }} 发布</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="babyTabActive === 4">
                <el-table
                  :data="babyPoopList"
                  class="order-table table baby-table"
                  ref="orderTable"
                  style="margin-top: 0;"
                  border
                  :header-cell-style="{
                    border: 'none',
                    color: '#666',
                    fontWeight: 'normal',
                    background: '#f6f6f6',
                    borderBottom: '1px solid #E8E8E8',
                    height: '32px',
                    fontSize: '14px',
                  }"
                  :row-style="{
                    height: '32px',
                    fontSize: '14px',
                  }"
                >
                  <el-table-column
                    prop="poopStatus"
                    align="center"
                    label="便便状态"
                  >
                  </el-table-column>
                  <el-table-column prop="pics" align="center" label="图片">
                    <div slot-scope="scope">
                      <el-image
                        class="brand-pic"
                        v-for="(item, index) in scope.row.pics"
                        :key="index"
                        :src="item"
                        style="width: 32px;height: 32px;"
                        :preview-src-list="scope.row.pics"
                      >
                      </el-image>
                    </div>
                  </el-table-column>
                  <el-table-column
                    prop="created"
                    align="center"
                    label="日期时间"
                    width="180"
                  ></el-table-column>
                  <el-table-column
                    prop="nickname"
                    align="center"
                    label="维护人昵称"
                    width="90"
                  ></el-table-column>
                  <el-table-column
                    prop="familyRole"
                    align="center"
                    label="维护人角色"
                    width="90"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="portrait-box" v-if="tabActive === 3">
            <div class="label">
              <div class="title">用户标签</div>
              <div class="tag-list">
                <div
                  class="tag-item"
                  v-for="(item, index) in portrait"
                  :key="index"
                >
                  <div class="tag-name">{{ item.name }}</div>
                  <div class="click-list">
                    <div
                      class="click-item"
                      v-for="(item2, index2) in item.info"
                    >
                      <span>{{ item2.behaviorName }}</span
                      >{{ item2.number }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="preference">
              <div class="title">用户偏好</div>
              <div class="box">
                <div class="left">
                  <div class="top">
                    <div class="brand" v-if="hobby.brand">
                      <div class="sub-title">品牌偏好</div>
                      <div class="item" v-for="(item, index) in hobby.brand">
                        {{ item }}
                      </div>
                    </div>
                    <div class="good" v-if="hobby.product">
                      <div class="sub-title">商品偏好</div>
                      <div class="item" v-for="(item, index) in hobby.product">
                        {{ item }}
                      </div>
                    </div>
                  </div>
                  <div v-if="hobby.collect">
                    <div class="sub-title">最近收藏（商品和位置最近5条）</div>
                    <div class="item" v-for="(item, index) in hobby.collect">
                      {{ item }}
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div style="height: 180px" v-if="hobby.read">
                    <div class="sub-title">最新阅读（显示最近3个）</div>
                    <div class="item" v-for="(item, index) in hobby.read">
                      {{ item }}
                    </div>
                  </div>
                  <div class="sub-title">最近一次咨询标题和结论</div>
                  <div class="item">无</div>
                  <div class="result">
                    无
                  </div>
                </div>
              </div>
            </div>
            <div class="record">
              <div class="title">咨询记录</div>
              <div class="list">
                <div
                  class="item"
                  v-for="item in chatList"
                  :key="item.id"
                  @click="handleChatModal(item.id)"
                >
                  <div class="left">
                    <span v-if="item.type === 2">人工咨询</span>
                    <span v-if="item.type === 3">AI咨询</span>
                    <div class="date">{{ item.created }}</div>
                  </div>
                  <div class="right">查看详情</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="修改手机号"
      :visible.sync="phoneVisible"
      width="460px"
      class="dialog"
    >
      <el-form
        ref="form"
        v-model="phoneForm"
        class="add-hz-form"
        label-width="80px"
      >
        <el-form-item label="手机号" prop="company">
          <input
            class="form-input"
            placeholder="请输入手机号"
            v-model="phoneForm.phone"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="phoneVisible = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="addPhone"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="咨询详情"
      :visible.sync="contactVisible"
      width="800px"
      class="dialog"
    >
      <div class="contact-box">
        <div class="info" v-if="chatInfo.summary">
          <!-- <div class="title">
            咨询标题标题标题
          </div> -->
          <div class="result">结论：{{ chatInfo.summary }}</div>
        </div>
        <div class="contact-list">
          <div class="item" v-for="item in chatMsgList" :key="item.id">
            <div class="left" v-if="item.origin === 3">
              <div class="avatar">
                <img class="img" :src="userDetail.avatar" fit="cover" />
              </div>
              <p>{{ item.content }}</p>
            </div>
            <div class="right" v-if="item.origin === 5">
              <p>
                {{ item.content }}
              </p>
              <div class="avatar">
                <img class="img" :src="staticImg ? staticImg + 'chat-01.png' : ''" fit="cover" v-if="item.type === 2"/>
                <img class="img" :src="staticImg ? staticImg + 'chat-02.png' : ''" fit="cover" v-if="item.type === 3"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="contactVisible = false"
        >
          取 消
        </button>
        <button class="confirm-btn" style="height: 32px; width: 60px">
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改宝宝币余额"
      :visible.sync="balanceVisible"
      width="460px"
      class="dialog"
    >
      <el-form
        ref="form"
        v-model="balanceForm"
        class="add-hz-form"
        label-width="80px"
      >
        <el-form-item label="修改方式:">
          <el-radio v-model="balanceForm.way" :label="1">添加</el-radio>
          <el-radio v-model="balanceForm.way" :label="2">扣除</el-radio>
        </el-form-item>
        <el-form-item label="输入额度:" prop="company">
          <input
            class="form-input"
            placeholder="请输入"
            onkeypress="/([0-9]|\.)/.test(event.key)"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
            v-model.number="balanceForm.number"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="balanceVisible = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="addBalance"
        >
          确 定
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '@/components/common/header';
import echarts from 'echarts';
import JSEncrypt from 'jsencrypt';
import pubKey from '@/assets/js/pubKey.js';
import { levelMap } from '@/config.js';
import { staticImg } from '@/config'; // oss 图片地址

export default {
  components: {
    Header
  },
  name: 'user-detail',
  data() {
    return {
      loading: 0, // 加载中
      labelWidth: '200px',
      staticImg: staticImg,
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '用户详情'
      },
      uid: null,
      userDetail: {},
      roleMap: {
        0: '普通用户',
        1: '会员'
      },
      feedModeMap: {
        1: '母乳',
        2: '奶粉喂养',
        3: '母乳+奶粉喂养',
        4: '暂未喂养'
      },
      balanceVisible: false,
      balanceForm: {
        number: null, 
        way: 1
      },
      phoneVisible: false,
      phoneForm: {
        phone: ''
      },
      tabActive: 1,
      tabList: [
        {
          name: '家庭信息',
          value: 1
        },
        {
          name: '宝宝信息',
          value: 2
        },
        {
          name: '用户画像',
          value: 3
        }
      ],
      type: 1,
      list: [],
      familyList: [],
      babyList: [],
      babyTabActive: null,
      babyTabList: [
        {
          name: '喂养记录',
          value: 1
        },
        {
          name: '身高体重',
          value: 2
        },
        {
          name: '备注',
          value: 3
        },
        {
          name: '便便记录',
          value: 4
        },
      ],
      bid: null,
      recordFeedList: [],
      feedModeMap: {
        1: '母乳',
        2: '配方奶',
        3: '混合喂养'
      },
      growthRemarkList: [],
      babyPoopList: [],
      timeStamp: +new Date(),
      myChart: null,
      option: {
        color: ['#618EFF', '#00BAAD'],
        legend: {
          data: ['宝宝身高', '宝宝体重']
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [],
            name: '宝宝身高',
            smooth: true,
            type: 'line',
            lineStyle: {
              width: 0
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(97, 142, 255, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(97, 142, 255, 0)'
                }
              ])
            },
          },
          {
            data: [],
            name: '宝宝体重',
            smooth: true,
            type: 'line',
            lineStyle: {
              width: 0
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(0, 186, 173, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(0, 186, 173, 0)'
                }
              ])
            }
          },
        ]
      },
      userTagList: [{}],
      contactVisible: false,
      hobby: {},
      portrait: [],
      chatList: [],
      chatId: null,
      chatInfo: {},
      chatMsgList: []
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted() {
    // 获取用户详情
    let query = this.$route.query;
    // this.getDictionary();
    if (query.uid) {
      this.uid = +query.uid;
      this.getUserInfo();
      this.getFamilyListByUid();
      this.getBabyListByUid();
      this.getPortraitByUid();
      this.getChatListByUid();
    }
  },
  computed: {},
  methods: {
    // 获取用户详情
    getUserInfo() {
      this.loading++;
      this.httpGet(this.$root.getUserInfo, {
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.userDetail = res.userInfo;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getFamilyListByUid(){
      this.loading++;
      this.httpGet(this.$root.getFamilyListByUid, {
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.familyList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getBabyListByUid(){
      this.loading++;
      this.httpGet(this.$root.getBabyListByUid, {
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.babyList = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getBabyRecordList(){
      this.loading++;
      this.httpGet(this.$root.getBabyRecordList, {
        bid: this.bid,
        way: this.babyTabActive
      }).then(
        (res) => {
          this.loading--;
          this.timeStamp = +new Date();
          switch(this.babyTabActive){
            case 1:
              this.recordFeedList = res.list.recordFeedList;
              break;
            case 2:
              res.list.GrowthList.forEach((item) => {
                this.option.xAxis.data.push(dayjs(item.growthTime).format('MM-DD'));
                this.option.series[0].data.push(item.height);
                this.option.series[1].data.push(item.weight);
              });
              this.$nextTick(() => {
                this.myChart = echarts.init(document.getElementById('echarts'));
                console.log(this.option);
                this.myChart.setOption(this.option);
              });
              break;
            case 3:
              this.growthRemarkList = res.list.growthRemarkList;
              break;
            case 4:
              this.babyPoopList = res.list.babyPoopList;
              break;
            default:
              break;
          }
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getPortraitByUid(){
      this.loading++;
      this.httpGet(this.$root.getPortraitByUid, {
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.hobby = res.hobby;
          this.portrait = res.portrait;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getChatListByUid(){
      this.loading++;
      this.httpGet(this.$root.getChatListByUid, {
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.chatList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleChatModal(id){
      this.chatId = id;
      this.getChatInfo();
      this.getChatMsgList();
      this.contactVisible = true;
    },
    getChatInfo(){
      this.loading++;
      this.httpGet(this.$root.getChatInfo, {
        id: this.chatId,
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.chatInfo = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getChatMsgList(){
      this.loading++;
      this.httpGet(this.$root.getChatMsgList, {
        id: this.chatId,
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.chatMsgList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleBabyInfo(bid){
      this.bid = bid;
      if(!this.babyTabActive){
        this.babyTabActive = 1;
      }
      this.getBabyRecordList();
    },
    getDictionary(){
      // this.getDictionaryByName('role');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          // this[dataName] = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    tabChange(active){
      this.tabActive = active;
      this.type = active;
    },
    babyTabChange(active){
      this.babyTabActive = active;
      this.getBabyRecordList();
    },
    addBalanceModal() {
      this.balanceForm = { number: null, way: 1 };
      this.balanceVisible = true;
    },
    addBalance(){
      if (!this.balanceForm.number) {
        this.$message.error('请输入宝宝币余额');
        return;
      }
      this.loading++;
      this.httpPut(this.$root.updateBalance, {
        uid: +this.uid,
        ...this.balanceForm
      }).then(
        (res) => {
          this.balanceVisible = false;
          this.$message.success('操作成功');
          this.loading--;
          this.getUserInfo();
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    },
    // 修改手机号
    addPhoneModal() {
      this.phoneForm = { phone: '' };
      this.phoneVisible = true;
    },
    addPhone() {
      this.loading++;
      this.httpPut(this.$root.updatePhone, {
        uid: +this.uid,
        ...this.phoneForm
      }).then(
        (res) => {
          this.phoneVisible = false;
          this.$message.success('操作成功');
          this.loading--;
          this.getUserInfo();
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.user-detail-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      width: 100%;
      height: 100%;
      font-size: 14px;
      box-sizing: border-box;
      border-radius: 2px;
      flex-y(flex-start, flex-start);

      .info-box {
        // flex: 1;
        flex-y(flex-start, flex-start);
        padding: 32px;
        background: white;
        box-sizing: border-box;
        // height: 100%;
        width: 100%;
        margin-bottom: 12px;

        .title {
          font-size: 18px;
          color: gray3;
          // width: 225px;
          // min-width: 225px;
          font-weight: bold;
        }

        .img-box {
          flex-y(center, flex-start);
          // width: 24%;
          // min-width: 160px;
          white-space: nowrap;
          word(14px, gray3);
          margin-right: 50px;
          width: 120px;

          >div {
            width: 100%;
            flex-y(center, center);
            .btn{
              width: 96px;
              height: 24px;
              border-radius: 12px;
              margin-top: 12px;
              background: #40B98F;
              flex-x(center);
              word(12px, #fff);
              cursor: pointer;
            }
          }

          .img {
            width: 80px;
            min-width: 80px;
            height: 80px;
            min-height: 80px;
            border-radius: 40px;
            // margin-right: 50px;
            // margin-bottom: 8px;
          }
        }

        .info {
          width: 100%;
          flex-x(flex-start);
          padding-top: 48px;
          box-sizing: border-box;

          .des {
            width: 100%;
            flex-x(flex-start, flex-start);
            flex-wrap: wrap;
            flex: 1;

            .item {
              min-width: 320px;
              flex-wrap: wrap;

              p {
                font-size: 14px;
                line-height: 36px;

                // white-space: nowrap;
                .btn {
                  width: auto;
                  line-height: 24px;
                  border-radius: 12px;
                  display: inline-block;
                  padding: 0 12px;
                  background: btn-color;
                  margin-right: 8px;
                }
              }

              .btn {
                width: 72px;
                height: 22px;
                background: #DA593E;
                font-size: 12px;
                line-height: 22px;
                text-align: center;
                margin-left: 15px;
                color: #fff;
                border-radius: 4px;
                cursor: pointer;
              }
            }
          }
        }
      }

      .bottom-box{
        width: 100%;
        border-radius: 10px;
        overflow: hidden;
        flex: 1;
        flex-y(flex-start, flex-start);
      }

      .tabs {
        width: 100%;
        background: #fff;
        height: 60px;
        flex-x(flex-start);
        padding: 0 30px;
        box-sizing: border-box;
        margin-top: 8px;
        flex-shrink: 0;

        .tab {
          background: #fff;
          cursor: pointer;
          padding: 0 15px;
          position: relative;
          width: auto;
          margin-right: 100px;
          height: 100%;
          flex-x(center);
          word(16px, #999);

          &.active {
            word(16px, #333);

            .tab-line {
              width: 38px;
              position: absolute;
              background: #4678E6;
              height: 3px;
              border-radius: 2px;
              left: 50%;
              transform: translateX(-50%);
              bottom: 0;
            }
          }
        }
      }
      .family-box{
        width: 100%;
        .family-item{
          flex-x(flex-start, flex-start);
          background: #fff;
          margin-top: 1px;
          padding: 12px 0;
          .left{
            width: 150px;
            height: 100%;
            flex-x(center);
            align-self: center;

            div{
              word(48px, #C9C9C9);
            }
          }
          .info{
            line-height: 32px;
            word(14px, #333);
            flex-y(flex-start);
            margin-right: 60px;
            .row{
              flex-x(flex-start);
            }
            .row:nth-of-type(1) {
              font-weight: bold;
            }
            .info-left{
              width: 120px;
            }
            .info-right{
              min-width: 200px;
            }
          }
          .member-box{
            flex-x(flex-start, flex-start);
          }
        }
      }
      >>>.baby-btn-box .cell{
        overflow: visible !important;
      }
      .baby-box{
        width: 100%;
        box-sizing: border-box;
        padding: 0 25px 18px;
        background: #fff;
        flex-x(flex-start, flex-start);

        .baby-table-box{
          width: 800px;
          margin-top: 20px;
          .baby-table{
            overflow: visible;
            >>>.el-table__body-wrapper{
              overflow: visible;
            }
          }
        }
        .table-btn-box{
          position: relative;
          .arrow{
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 8px solid #5283FF;
            position: absolute;
            right: -55px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .baby-right{
          margin-left: 60px;
          .tabs{
            height: 36px;
            margin-top: 0;
            margin-bottom: 20px;
            .tab{
              margin-right: 10px;
            }
          }
          .remark-item{
            width: 500px;
            background: #F2F2F2;
            border: 1px solid #E3E3E3;
            border-radius: 5px;
            padding: 20px;
            margin-bottom: 10px;
            .text{
              line-height: 20px;
              word(14px, #333);
            }
            .pics{
              margin-top: 10px;
            }
            .remark-bottom{
              margin-top: 24px;
              flex-x();
              word(12, #666);
            }
          }
        }
      }
      .portrait-box{
        width: 100%;
        flex-x(flex-start, flex-start);
        flex: 1;
        .title{
          height: 50px;
          flex-x(flex-start);
          word(16px, #333);
          font-weight: bold;
        }
        .label{
          width: 260px;
          min-width: 260px;
          height: 100%;
          background: #fff;
          padding-left: 24px;
          padding-right: 32px;
          box-sizing: border-box;
          margin-top: 3px;
          .tag-list{
            flex: 1;
            overflow-y: auto;
            .tag-item{
              flex-y(flex-start, flex-start);
              .tag-name{
                padding: 0 16px;
                height: 30px;
                border-radius: 5px;
                background: #E8E8E8;
                // margin-top: 18px;
                flex-x(center);
              }
            }
          }
          .click-list{
            width: 100%;
            flex-y(flex-start, flex-start);
            box-sizing: border-box;
            padding-left: 5px;
            margin-top: 5px;
            .click-item{
              width: 100%;
              height: 24px;
              flex-x();
              word(14px, #666);
              span{
                flex: 1;
              }
            }
          }
        }
        .preference{
          flex: 1;
          background: #fff;
          height: 100%;
          margin: 3px 3px 0;
          padding: 0 25px;
          box-sizing: border-box;
          .sub-title{
            height: 36px;
            flex-x(flex-start);
            word(14px, #666);
          }
          .item{
            height: 30px;
            margin: 3px 0;
            padding: 0 18px;
            background: #E8E8E8;
            border-radius: 5px;
            word(14px, #666);
            flex-x(flex-start);
          }
          .box{
            flex-x();
            height: 100%;
            .top{
              height: 180px;
              flex-x(flex-start, flex-start);

            }
          }
          .right{
            width: 40%;
            height: 100%;
            flex-y(flex-start, flex-start);
            .result{
              word(12px, #333);
              margin-top: 12px;
              line-height: 18px;
            }
          }
          .left{
            width: 60%;
            height: 100%;
            flex-y(flex-start, flex-start);
            .top{
              width: 100%;
              >div{
                flex-y(flex-start, flex-start);
                flex: 1;
                border-right: 1px solid #DBDBDB;
                margin-right: 24px;
              }
            }
          }
        }
        .record{
          width: 420px;
          min-width: 420px;
          height: 100%;
          background: #fff;
          margin-top: 3px;
          padding: 0 20px;
          box-sizing: border-box;
          flex-y(flex-start);
          .list{
            width: 100%;
            flex-y(flex-start);
            flex: 1;
            overflow-y: auto;
            .item{
              height: 50px;
              width: 100%;
              flex-x(space-between, center);
              .left{
                flex-y(center, flex-start);
                word(14px, #333);
                .date{
                  word(12px, #999);
                  margin-top: 3px;
                }
              }
              .right{
                word(14px, #154CC2);
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  .add-hz-form {
    padding-top: 15px;
    flex-y(flex-start, center);

    .form-input {
      width: 300px;
      height: 32px;
      margin-left: 3px;
      margin-right: 16px;
      border-radius: 5px;
      padding: 0 12px;
      border: 1px solid #ccc;
      box-sizing: border-box;
      word(13px, #333);
    }
  }

  .api-dialog {
    padding: 0 60px;
    box-sizing: border-box;

    .item {
      line-height: 60px;
    }
  }

  .contact-box{
    .info{
      border-bottom: 1px solid #E0E0E0;
      .title{
        word(14px, #333);
        font-weight: bold;
        margin-top: 10px;
      }
      .result{
        word(14px, #666);
        margin-top: 8px;
        line-height: 20px;
        margin-bottom: 20px;
      }
    }
    .contact-list{
      flex-y(flex-start, flex-start);
      max-height: 500px;
      overflow-y: auto;
      padding-bottom: 20px;

      .item{
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .avatar{
        width: 32px;
        height: 32px;
        border-radius: 16px;
        background: #ccc;
        flex-shrink: 0;
        overflow: hidden;
        .img{
          width: 100%;
          height: 100%;
        }
      }
      p{
        line-height: 18px;
        padding: 8px 18px;
      }
      .left{
        flex-x(flex-start, flex-start);
        margin-top: 20px;
        p{
          word(12px, #333);
          background: #F7F7F7;
          border-radius: 8px;
          margin-left: 8px;
        }
      }
      .right{
        flex-x(flex-end, flex-start);
        margin-top: 20px;
        p{
          word(12px, #333);
          background: #F7F7F7;
          border-radius: 8px;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
